import React, { Component } from "react";
import { SettingHeader, ShowInfoPanel, DobEditInfoPanel } from "./../TutorSetting/SpecificSettingComp";
import warning from "../../assets/icons/warning.png";
import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { getLangLat, updateTutorSettings, getSetting, sendCode, verifyCode } from "./../../apis/tutors";
import { TutorSettingAction } from "./../../redux/actions";
import { InfoModal } from "./../../components/modals/InfoModal";
import { debounce } from "lodash";
import PasswordConfirmationModal from "../../components/modals/PasswordConfirmation.Modal";

class PersonalInformation extends Component {
	constructor() {
		super();

		this.state = {
			num1: "",
			num2: "",
			num3: "",
			num4: "",
			panel: "",
			email: "",
			open: false,
			CodeInput: "",
			townReq: false,
			streetReq: false,
			verifyFail: false,
			verifyMode: false,
			phoneError: false,
			postCodeArray: [],
			searchmode: false,
			lastNameReq: false,
			postCodeReq: false,
			previousAddress: {},
			firstNameReq: false,
			postcodeLoader: false,
			previousAddressRaw: "",
			onFocusPhoneNumber: false,
			tutorSettingDataState: {},
			tutorSettingDataFinalState: {},
			genders: [ "Male", "Female", "Other" ],
		};

		this.num1Input = React.createRef();
		this.num2Input = React.createRef();
		this.num3Input = React.createRef();
		this.num4Input = React.createRef();

	}

	componentDidMount = () => {

		const { tutorSettingData } = this.props;
		let user = JSON.parse(localStorage.getItem("userDetail"));

		this.setState({ tutorSettingDataState: tutorSettingData, tutorSettingDataFinalState: tutorSettingData, email: user?.email });

	}

	componentDidUpdate = () => {
		const { tutorSettingData } = this.props;
		const { tutorSettingDataState } = this.state;
		if ( !tutorSettingDataState?.tutorDetails && tutorSettingData?.tutorDetails ) {
			this.setState({ tutorSettingDataState: { ...tutorSettingData }, tutorSettingDataFinalState: { ...tutorSettingData } });
		}
	}

	CancelPanel = () => {
		const { tutorSettingDataFinalState } = this.state;
		let user = JSON.parse(localStorage.getItem("userDetail"));

		this.setState({
			email: user.email,
			tutorSettingDataState: { ...tutorSettingDataFinalState },
			panel: "",
			firstNameReq: false,
			lastNameReq: false,
			postCodeReq: false,
			streetReq: false,
			townReq: false,
			verifyMode: false,
			NumberSentError: "",
			verifyFail: "",
		});
	}

	resetAddress = () => {
		
		let { tutorSettingDataState, previousAddress, previousAddressRaw } = this.state;

		tutorSettingDataState.address = previousAddress;
		tutorSettingDataState.addressRaw = previousAddressRaw;

		this.setState({ tutorSettingDataState })

	}

	saveEmergencyContact = () => {
		let { tutorSettingDataState } = this.state;
		this.setState({
			tutorSettingDataState,
			panel: "",
		});
		this.onSave();
	}

	getLanlatThenSave = () => {
		let { tutorSettingDataState } = this.state;
		return tutorSettingDataState?.address?.street &&
		tutorSettingDataState?.address?.town &&
		tutorSettingDataState?.address?.postCode
		? getLangLat(
			`${tutorSettingDataState.address.street} ${
				tutorSettingDataState.address.town
			} ${
				tutorSettingDataState.address.county
				? tutorSettingDataState.address.county
				: ""
			} ${tutorSettingDataState.address.postCode}`
			)
			.then((res) => {
				tutorSettingDataState.tutorDetails.addressLatLng._latitude =
				res.results[0].locations[0].latLng.lat;
				tutorSettingDataState.tutorDetails.addressLatLng._longitude =
				res.results[0].locations[0].latLng.lng;
				this.setState({
				tutorSettingDataState,
				tutorSettingDataFinalState: { ...tutorSettingDataState },
				panel: "",
				});
				this.onSave();
			})
			.catch((err) => console.log(err))
		: this.setState({
			streetReq: true,
			townReq: true,
			postCodeReq: true,
			});
	}

	onSave = () => {
		const { tutorSettingDataState } = this.state;
		let updateTutorObj = { ...tutorSettingDataState };
		let tutorDetails = { ...updateTutorObj.tutorDetails };
		delete tutorDetails.address;
		delete tutorDetails.addressRaw;
		delete updateTutorObj.tutorDetails;
		updateTutorObj = { ...updateTutorObj, ...tutorDetails };
		let user = JSON.parse(localStorage.getItem("userDetail"));
		let user_id = user.user.userId;
		let updateSettingParam = {
		updateSetting: {
			firstName: updateTutorObj.firstName,
			lastName: updateTutorObj.lastName,
			phoneNumber: updateTutorObj.phoneNumber,
			address: updateTutorObj.address,
			addressRaw: updateTutorObj.addressRaw,
			gender: updateTutorObj.gender,
			dob: String(updateTutorObj?.dob),
			emergencyContact: updateTutorObj.emergencyContact,
			addressLatLng: updateTutorObj?.addressLatLng,
		},
		};
		updateTutorSettings(updateSettingParam)
		.then((res) => {
			this.setState({
			panel: "",
			tutorSettingDataFinalState: { ...tutorSettingDataState },
			});
			InfoModal("Updates", "Successfully Update");
			// getSetting({ user_id })
			//   .then((res) => {
			//     this.props.TutorSettingStoreData(res.data);
			//     this.setState({
			//       tutorSettingDataState: {},
			//     });
			//     InfoModal("Updates", "Successfully Update");

			//     // this.props.onHide();
			//     // this.props.onSuccess();
			//   })
			//   .catch((err) => console.log(err));
		})
		.catch((err) => console.log(err, "==="));
	}

	setDateInState = (e) => {
		let { tutorSettingDataState } = this.state;
		if (tutorSettingDataState?.dob) {
			if (tutorSettingDataState?.dob) {
				tutorSettingDataState.dob = new Date(e).getTime();
			} else {
				tutorSettingDataState["dob"] = new Date(e).getTime();
			}
		} else {
			tutorSettingDataState["dob"] = {};
			tutorSettingDataState.dob = new Date(e).getTime();
		}
		return tutorSettingDataState;
	}

	SelectDate = (e) => {
		let result = this.setDateInState(e);
		this.setState({
		tutorSettingDataState: result,
		});
	}

	onChangeState = (e) => {
		let { tutorSettingDataState } = this.state;

		tutorSettingDataState = tutorSettingDataState ? tutorSettingDataState : {};
		
		if (tutorSettingDataState) {
			if (!tutorSettingDataState["address"]) {
				tutorSettingDataState["address"] = {};
			}
		} else {
			tutorSettingDataState = {};
			tutorSettingDataState["address"] = {};
		}
		
		tutorSettingDataState["address"][e.target.name] = e.target.value;
				
		let address1 = tutorSettingDataState.address?.street ? tutorSettingDataState.address?.street + ", " : "";
		let address2 = tutorSettingDataState.address?.address2 ? tutorSettingDataState.address?.address2 + ", " : "";
		let apartment = tutorSettingDataState.address?.suit ? tutorSettingDataState.address?.suit + ", " : "";
		let city = tutorSettingDataState.address?.town ? tutorSettingDataState.address?.town + ", " : "";
		let country = tutorSettingDataState.address?.county ? tutorSettingDataState.address?.county + ", " : "";
		let postCode = tutorSettingDataState.address?.postCode ? tutorSettingDataState.address?.postCode : "";
		
		tutorSettingDataState.addressRaw = `${address1}${apartment}${address2}${city}${country}${postCode}`;

		this.setState({ tutorSettingDataState, [`${[e.target.name]}Req`]: true });

	}

	getPostCode = debounce((text) => {
		this.setState({
		postcodeLoader: true,
		});
		let isInputFieldEmptyRE = /^\s*$/;
		if (!isInputFieldEmptyRE.test(text)) {
		fetch(`https://api.postcodes.io/postcodes/${text}/autocomplete`)
			.then((response) => {
			return response.json();
			})
			.then((response) => {
			if (response.status === 200) {
				this.setState({
				postCodeArray: response.result,
				searchmode: true,
				postcodeLoader: false,
				});
			}
			})
			.catch((error) => {
			this.setState({
				postcodeLoader: false,
			});
			});
		} else {
		this.setState({
			searchmode: false,
			postcodeLoader: false,
			postCodeArray: [],
		});
		}
	}, 200)

	onSelectState = (value, name) => {

		let { tutorSettingDataState } = this.state;

		tutorSettingDataState = tutorSettingDataState ? tutorSettingDataState : {};
		
		if (tutorSettingDataState) {
			if (!tutorSettingDataState["address"]) {
				tutorSettingDataState["address"] = {};
			}
		} else {
			tutorSettingDataState = {};
			tutorSettingDataState["address"] = {};
		}
		
		tutorSettingDataState["address"][name] = value;
					
		let address1 = tutorSettingDataState.address?.street ? tutorSettingDataState.address?.street + ", " : "";
		let address2 = tutorSettingDataState.address?.address2 ? tutorSettingDataState.address?.address2 + ", " : "";
		let apartment = tutorSettingDataState.address?.suit ? tutorSettingDataState.address?.suit + ", " : "";
		let city = tutorSettingDataState.address?.town ? tutorSettingDataState.address?.town + ", " : "";
		let country = tutorSettingDataState.address?.county ? tutorSettingDataState.address?.county + ", " : "";
		let postCode = tutorSettingDataState.address?.postCode ? tutorSettingDataState.address?.postCode : "";
		
		tutorSettingDataState.addressRaw = `${address1}${apartment}${address2}${city}${country}${postCode}`;

		this.setState({ tutorSettingDataState, searchmode: false, postCodeArray: [] });

	}

	onClickVerify = () => {

		const { phoneError, verifyMode, tutorSettingDataState } = this.state;

		if( !tutorSettingDataState?.phoneNumber || tutorSettingDataState?.phoneNumber?.length !== 10 ) {

			this.setState({ phoneError: true })

		}
		else if( tutorSettingDataState?.phoneNumber && tutorSettingDataState?.phoneNumber?.length === 10 ) {
			
			if( phoneError ) {

				this.setState({ phoneError: false, verifyMode: true })

			}
			else this.setState({ verifyMode: true })

		}
						
	}

	handleFocus = (e) => e.target.select();

	handleChange = (e, num) => {

		const { num1, num2, num3, num4 } = this.state;

		if (num === 1 && e.target.value.length <= 1) {
			this.setState({ num1: e.target.value, CodeInput: e.target.value + num2 + num3 + num4 });
			if (e.target.value.length === 1) {
				this.num2Input.current.focus();
			}
		}
		if (num === 2 && e.target.value.length <= 1) {
			this.setState({ num2: e.target.value, CodeInput: num1 + e.target.value + num3 + num4 });
			if (e.target.value.length === 1) {
				this.num3Input.current.focus();
			} else this.num1Input.current.focus();
		}
		if (num === 3 && e.target.value.length <= 1) {
			this.setState({ num3: e.target.value, CodeInput: num1 + num2 + e.target.value + num4 });
			if (e.target.value.length === 1) {
				this.num4Input.current.focus();
			} else this.num2Input.current.focus();
		}
		if (num === 4 && e.target.value.length <= 1) {
			this.setState({ num4: e.target.value, CodeInput: num1 + num2 + num3 + e.target.value });
			if (e.target.value.length !== 1) {
				this.num3Input.current.focus();
			}
		}
	}

	handleKey = (e, num) => {
		if (num === 1) {
			if (e.keyCode === 39) {
				this.num2Input.current.focus();
				this.num2Input.current.select();
			}
			if (e.keyCode === 37) {
				this.num4Input.current.focus();
				this.num4Input.current.select();
			}
		}
		if (num === 2) {
			if (e.keyCode === 39) {
				this.num3Input.current.focus();
				this.num3Input.current.select();
			}
			if (e.keyCode === 37) {
				this.num1Input.current.focus();
				this.num1Input.current.select();
			}
		}
		if (num === 3) {
			if (e.keyCode === 39) {
				this.num4Input.current.focus();
			}
			if (e.keyCode === 37) {
				this.num2Input.current.focus();
			}
		}
		if (num === 4) {
			if (e.keyCode === 39) {
				this.num1Input.current.focus();
			}
			if (e.keyCode === 37) {
				this.num3Input.current.focus();
			}
		}
	}

	render() {
		let monthArray = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
		];
		let {
			num1,
			num2,
			num3,
			num4,
			open,
			panel,
			email,
			townReq,
			genders,
			CodeInput,
			streetReq,
			verifyFail,
			verifyMode,
			phoneError,
			searchmode,
			lastNameReq,
			postCodeReq,
			firstNameReq,
			postCodeArray,
			postcodeLoader,
			NumberSentError,
			previousAddress,
			previousAddressRaw,
			onFocusPhoneNumber,
			tutorSettingDataState,
		} = this.state;
		let dob = new Date(Number(tutorSettingDataState?.dob));
		let date = dob?.getDate();
		let month = monthArray[dob?.getMonth()];
		let year = dob?.getFullYear();
		const { isModalPersonalInfo, onHide, user } = this.props;

		let warningError = (

			<img src={warning} alt="warning" width="14px" height="14px" style={{ marginRight: "6px" }} />

		);

		const emailRegExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

		let color, borderColor, backgroundColor;

		if (onFocusPhoneNumber && (!phoneError)) {
			color = "";
			borderColor = "#2cb46d";
			backgroundColor = "";
		} 
		else if ( ( !tutorSettingDataState?.phoneNumber || tutorSettingDataState?.phoneNumber?.length !== 10 ) && phoneError) {
			color = "#fa4a4a";
			borderColor = "#fa4a4a";
			backgroundColor = "#fff1f1";
		} else {
			color = "";
			borderColor = "";
			backgroundColor = "";
		}
		
		if( CodeInput.length === 4 && CodeInput !== "1234" && !verifyFail ) {
			this.setState({ verifyFail: true })
		}
		else if( verifyFail && CodeInput === "1234" ) {
			this.setState({ verifyFail: false })
		}

		return (
		<div className="container">
			<Row className="flex-center-center">
				<Col lg={8} md={8} sm={12} xs={12} className="personal-information">
					<SettingHeader
						settingName={"Personal info"}
						headerTitle={"Personal information"}
						headerDesciption={"Members of Askademia do not see these details we only share contact details with parents or student after a lesson is confirmed"}
						goToAccount={() => this.props.history.push("/tutor-setting")}
					/>

					{ panel === "name" ? (
						<div>		
							<div className="flex-between-center">
								<label className="title">Legal name</label>
								<button onClick={this.CancelPanel} className="green-unfill-btn">Cancel</button>
							</div>
							<p className="sub-title">This name must much the name on your ID Card, licence or passport provided.</p>
							<Row>
								<Col lg={6} md={6} sm={12} xs={12}>
									<label className="label">First name</label>
									<input
										type="text"
										name="firstName"
										value={ tutorSettingDataState?.firstName ? tutorSettingDataState?.firstName : "" }
										className={ 
											!tutorSettingDataState?.firstName && firstNameReq ? 
												"form-control errorInput" : "form-control"
										}
										onChange={ (e) => {
											tutorSettingDataState[e.target.name] = e.target.value;
											this.setState({ tutorSettingDataState, [`${e.target.name}Req`]: true }) 
										}}
									/>
									<div className="error">
										{ !tutorSettingDataState?.firstName && firstNameReq ? warningError : "" }
										{ !tutorSettingDataState?.firstName && firstNameReq ? "First name is required" : "" }
									</div>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12}>
									<label className="label">Last name</label>
									<input
										type="text"
										name="lastName"
										value={ tutorSettingDataState?.lastName ? tutorSettingDataState?.lastName : "" }
										className={ 
											!tutorSettingDataState?.lastName && lastNameReq ? 
												"form-control errorInput" : "form-control"
										}
										onChange={ (e) => {
											tutorSettingDataState[e.target.name] = e.target.value;
											this.setState({ tutorSettingDataState, [`${e.target.name}Req`]: true }) 
										}}
									/>
									<div className="error">
										{ !tutorSettingDataState?.lastName && lastNameReq ? warningError : "" }
										{ !tutorSettingDataState?.lastName && lastNameReq ? "Last name is required" : "" }
									</div>
								</Col>
							</Row>
							<button 
								className="green-button" 
								onClick={ 
									tutorSettingDataState?.firstName && tutorSettingDataState?.lastName ? 
										this.onSave : () => this.setState({ firstNameReq: true, lastNameReq: true })
								}
							>
								Save
							</button>
						</div>
					) : (
						<ShowInfoPanel
							ValueTitle={"Legal name"}
							disabled={panel ? panel === "name" : true}
							onEdit={() => this.setState({ panel: "name" })}
							infoValue={ 
								`${tutorSettingDataState?.firstName ? tutorSettingDataState?.firstName: ""} ${tutorSettingDataState?.lastName ? tutorSettingDataState?.lastName: ""}` 
							}
						/>
					)}

					<hr className="hr"/>

					{ panel === "gender" ? (
						<div>		
							<div className="flex-between-center">
								<label className="title">Gender</label>
								<button onClick={this.CancelPanel} className="green-unfill-btn">Cancel</button>
							</div>
							<DropdownButton
								id="dropdown-basic-button"
								title={
									<span>
										{ tutorSettingDataState?.gender ? tutorSettingDataState?.gender : "Select" }
										<img style={{ width: "15px" }} src={require("./../../assets/icons/down-arrow.png")}/>
									</span>
								}
							>
								{
									genders && genders.length ? (
										genders.map((gender, index) => {
										return (
											<Dropdown.Item
												key={index}
												className="dropdown-items"
												onClick={ (e) => {
													tutorSettingDataState.gender = gender;
													this.setState({ tutorSettingDataState })
												}}
											>
											{gender}
											</Dropdown.Item>
										);
									})
								) : (
									<Dropdown.Item className="dropdown-items">
									No Data
									</Dropdown.Item>
								)}
							</DropdownButton>					
							<button 
								className="green-button" 
								onClick={ tutorSettingDataState?.gender ? this.onSave : () => {} }
							>
								Save
							</button>
						</div>
					) : (
						<ShowInfoPanel
							ValueTitle={"Gender"}
							disabled={panel ? panel === "gender" : true}
							onEdit={ () => this.setState({ panel: "gender" }) }
							infoValue={ tutorSettingDataState?.gender ? tutorSettingDataState?.gender : "" }
						/>
					)}

					<hr className="hr"/>

					{ panel === "dob" ? (
						<DobEditInfoPanel
							ValueTitle={"Date of birth"}
							infoValue={
							tutorSettingDataState?.dob
								? Number(tutorSettingDataState?.dob)
								: null
							}
							onSelect={(e) => {
							this.SelectDate(e);
							}}
							onCancel={this.CancelPanel}
							onSave={tutorSettingDataState?.dob ? this.onSave : () => {}}
						/>
					) : (
						<ShowInfoPanel
							ValueTitle={"Date of birth"}
							disabled={panel ? panel === "dob" : true}
							onEdit={ () => this.setState({ panel: "dob" }) }
							infoValue={ tutorSettingDataState?.dob ? `${date} ${month} ${year}` : "" }
						/>
					)}

					<hr className="hr"/>
					
					{ panel === "email" ? (
						<div>		
							<div className="flex-between-center">
								<label className="title">Email address</label>
								<button onClick={this.CancelPanel} className="green-unfill-btn">Cancel</button>
							</div>
							<p className="sub-title">Use an address you'll always have access to.</p>
							<input
								type="email"
								name="email"
								value={ email }
								placeholder="Email address"
								onChange={ (e) => this.setState({ email: e.target.value }) }
								className={ !email || email === user?.email || !email.match(emailRegExp) ? "form-control errorInput mt-3" : "form-control mt-3" }
							/>
							<div className="error">
								{ !email || email === user?.email || !email.match(emailRegExp) ? warningError : "" }
								{ !email || !email.match(emailRegExp) ? "Email address is invalid" : "" }
								{ email === user?.email ? "Email has already been taken" : "" }
							</div>

							<button 
								className="green-button" 
								onClick={ 
									email && email !== user?.email && email.match(emailRegExp) ? 
										() => this.setState({ open: true }) : () => {}
								}
							>
								Save
							</button>
						</div>
					) : (
						<ShowInfoPanel
							infoValue={ email }
							ValueTitle={"Email address"}
							disabled={panel ? panel === "email" : true}
							onEdit={ () => this.setState({ panel: "email" }) }
						/>
					)}

					<hr className="hr"/>
					
					{ panel === "phone" ? (
						<div>		
							<div className="flex-between-center">
								<label className="title">Phone number</label>
								<button onClick={this.CancelPanel} className="green-unfill-btn">Cancel</button>
							</div>
							<p className="sub-title">For notifications, reminders and help logging in</p>
							<label className="title mt-3">Edit phone number</label>
							<div className="disabled">
								<span>United Kingdom (+44)</span>
								<i className="fa fa-lock"></i>
							</div>
							<div
								tabIndex="-1"
								className="comp_input"
								onBlur={ () => this.setState({ onFocusPhoneNumber: false }) }
								onFocus={ () => this.setState({ onFocusPhoneNumber: true }) }
								style={{ color: color, borderColor: borderColor, backgroundColor: backgroundColor }}
							>
								<span
									id="basic-addon1"
									className="mobile"
									onBlur={ () => this.setState({ onFocusPhoneNumber: false }) }
									onFocus={ () => this.setState({ onFocusPhoneNumber: true }) }
									style={{ color: onFocusPhoneNumber && !phoneError ? "#2cb46d" : color, borderColor: borderColor, backgroundColor: backgroundColor }}
								>
								+44
								</span>
								<input
									type="number"
									name="phoneNumber"
									aria-label="Username"
									aria-describedby="basic-addon1"
									onBlur={ () => this.setState({ onFocusPhoneNumber: false }) }
									onFocus={ () => this.setState({ onFocusPhoneNumber: true }) }
									className={ 
										( !tutorSettingDataState?.phoneNumber || tutorSettingDataState?.phoneNumber?.length !== 10 ) && phoneError ? 
										"form-control errorInput" : "form-control"
									}
									style={{ color: color, borderColor: borderColor, backgroundColor: backgroundColor }}
									value={ tutorSettingDataState?.phoneNumber ? tutorSettingDataState?.phoneNumber : "" }
									onChange={(e) => {
										tutorSettingDataState[e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState });
									}}
								/>
							</div>		
							{
								( !tutorSettingDataState?.phoneNumber || tutorSettingDataState?.phoneNumber?.length !== 10 ) && phoneError ? (
									<div className="error">
										{ warningError }
										{ !tutorSettingDataState?.phoneNumber ? "Please enter a valid phone number" : "" }
										{ tutorSettingDataState?.phoneNumber && tutorSettingDataState?.phoneNumber?.length !== 10 ? "You'll need to use a diﬀerent phone number as we can't support this one." : "" }
									</div>	
								) : ""												
							}
							{
								verifyMode ? (
									<div>
										<label className="title mt-3">Enter your security code</label>
										<p className="sub-title">
											We texted your code to +44 {tutorSettingDataState?.phoneNumber}. It may take a minute to
											arrive. You entered security code {CodeInput}{" "}
										</p>
										<div className="securityCode">
											<input
												id="num1"
												name="num1"
												value={num1}
												type="number"
												autoFocus={false}
												ref={this.num1Input}
												placeholder="&#x2015;"
												className={ verifyFail ? "error" : "" }
												onFocus={ ( e ) => this.handleFocus(e) }
												onKeyDown={ (e) => this.handleKey(e, 1) }
												onChange={ (e) => this.handleChange(e, 1) }
											/>
											<input
												id="num2"
												name="num2"
												value={num2}
												type="number"
												ref={this.num2Input}
												placeholder="&#x2015;"
												className={ verifyFail ? "error" : "" }
												onFocus={ ( e ) => this.handleFocus(e) }
												onKeyDown={ (e) => this.handleKey(e, 2) }
												onChange={ (e) => this.handleChange(e, 2) }
											/>
											<input
												id="num3"
												name="num3"
												value={num3}
												type="number"
												ref={this.num3Input}
												placeholder="&#x2015;"
												className={ verifyFail ? "error" : "" }
												onFocus={ ( e ) => this.handleFocus(e) }
												onKeyDown={ (e) => this.handleKey(e, 3) }
												onChange={ (e) => this.handleChange(e, 3) }
											/>
											<input
												id="num4"
												name="num4"
												value={num4}
												type="number"
												ref={this.num4Input}
												placeholder="&#x2015;"
												className={ verifyFail ? "error" : "" }
												onFocus={ ( e ) => this.handleFocus(e) }
												onKeyDown={ (e) => this.handleKey(e, 4) }
												onChange={ (e) => this.handleChange(e, 4) }
											/>
										</div>
										<div className="error">
											{ verifyFail ? warningError : "" }
											{ verifyFail ? "We are unable to validate your phone number. Please try again." : "" }
										</div>
										<p className="sub-title mt-3">
											Didn't get it? 
											<span>Try again</span>
										</p>
									</div>
								) : (
									<button className="green-button" onClick={ this.onClickVerify }>Verify</button>
								)
							}
							
						</div>
					) : (
						<ShowInfoPanel
							ValueTitle={"Phone Number"}
							disabled={panel ? panel === "phone" : true}
							onEdit={ () => this.setState({ panel: "phone" }) }
							infoValue={ tutorSettingDataState?.phoneNumber ? tutorSettingDataState?.phoneNumber : "" }
						/>
					)}

					<hr className="hr"/>
					
					{ panel === "address" ? (
						<div>		
							<div className="flex-between-center">
								<label className="title">Address</label>
								<button 
									className="green-unfill-btn"
									onClick={ () => {
										this.CancelPanel();
										this.resetAddress();
									}} 
								>
									Cancel
								</button>
							</div>
							<p className="sub-title">{ tutorSettingDataState?.addressRaw ? tutorSettingDataState?.addressRaw : "Not provided" }</p>
							<label className="label b">Address line 1</label>
							<input
								type="text"
								name="street"
								placeholder="Address line 1"
								onChange={this.onChangeState}
								value={ tutorSettingDataState?.address?.street ? tutorSettingDataState?.address?.street : "" }
								className={ !tutorSettingDataState?.address?.street && streetReq ? "form-control errorInput" : "form-control" }
							/>
							<div className="error">
								{ !tutorSettingDataState?.address?.street && streetReq ? warningError : "" }
								{ !tutorSettingDataState?.address?.street && streetReq ? "Please enter a maximum of 35 characters. " : "" }
							</div>
							
							<label className="label b">Apartment, Suite, Building Access Code (Optional)</label>
							<input
								type="text"
								name="suit"
								className="form-control"
								onChange={this.onChangeState}
								placeholder="Apartment, Suite, Building Access Code (Optional)"
								value={ tutorSettingDataState?.address?.suit ? tutorSettingDataState?.address?.suit : "" }
							/>

							<label className="label b">Address line 2</label>
							<input
								type="text"
								name="address2"
								className="form-control"
								placeholder="Address line 2"
								onChange={this.onChangeState}
								value={ tutorSettingDataState?.address?.address2 ? tutorSettingDataState?.address?.address2 : "" }
							/>

							<label className="label b">City or Town</label>
							<input
								type="text"
								name="town"
								placeholder="City or Town"
								onChange={this.onChangeState}
								value={ tutorSettingDataState?.address?.town ? tutorSettingDataState?.address?.town : "" }
								className={ !tutorSettingDataState?.address?.town && townReq ? "form-control errorInput" : "form-control" }
							/>
							<div className="error">
								{ !tutorSettingDataState?.address?.town && townReq ? warningError : "" }
								{ !tutorSettingDataState?.address?.town && townReq ? "Please enter your city or town" : "" }
							</div>

							<Row>
								<Col lg={6} md={6} sm={12} xs={12}>
									<label className="label b">County (Optional)</label>
									<input
										type="text"
										name="county"
										className="form-control"
										onChange={this.onChangeState}
										placeholder="County (Optional)"
										value={ tutorSettingDataState?.address?.county ? tutorSettingDataState?.address?.county : "" }
									/>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12}>
									<label className="label b">Postcode</label>
									<input
										type="text"
										name="postCode"
										placeholder="Postcode"
										value={ tutorSettingDataState?.address?.postCode ? tutorSettingDataState?.address?.postCode : "" }
										className={ !tutorSettingDataState?.address?.postCode && postCodeReq ? "form-control errorInput" : "form-control" }
										onChange={ (e) => {
											this.getPostCode(e.target.value);
											this.onChangeState(e);
										}}
									/>				
									<div className="error">
										{ !tutorSettingDataState?.address?.postCode && postCodeReq ? warningError : "" }
										{ !tutorSettingDataState?.address?.postCode && postCodeReq ? "Please enter a valid post code" : "" }
									</div>
									<div
										style={{
											display:
												postcodeLoader || searchmode || postCodeArray?.length
												? "flex"
												: "none",
										}}
										className={
											postcodeLoader || searchmode || postCodeArray?.length
												? "postcode-list-div"
												: ""
										}
									>
										{!postcodeLoader ? (
										searchmode && postCodeArray?.length ? (
											postCodeArray.map((post, index) => (
											<p 
												key={index} 
												style={{ cursor: "pointer", margin: "0px" }} 
												onClick={() => this.onSelectState(post, "postCode")}
											>
												<div className="flex-start-center post-value">
													<img className="img" src={require("./../../assets/icons/gps.png")}/>
													<span>{post}</span>
												</div>
											</p>
											))
										) : (
											"no post code"
										)
										) : (
										<div className="flex-center-center p-3">
											<Spinner
											animation="border"
											style={{ width: "25px", height: "25px" }}
											/>
										</div>
										)}
									</div>
								</Col>
							</Row>

							<button className="green-button" onClick={this.getLanlatThenSave}>Save</button>
						</div>
					) : (
						<ShowInfoPanel
							ValueTitle={"Address"}
							disabled={panel ? panel === "address" : true}
							infoValue={ tutorSettingDataState?.addressRaw ? tutorSettingDataState?.addressRaw : "" }
							onEdit={ () => {
								previousAddress = tutorSettingDataState?.address;
								previousAddressRaw = tutorSettingDataState?.addressRaw;
								this.setState({ panel: "address", previousAddress, previousAddressRaw }) 
							}}
						/>
					)}

					<hr className="hr"/>
					
					{ panel === "emergencyContact" ? (
						<div>		
							<div className="flex-between-center">
								<label className="title">Emergency contact</label>
								<button onClick={this.CancelPanel} className="green-unfill-btn">Cancel</button>
							</div>
							<p className="sub-title">An emergency contact we can contact in any urgent situation</p>
							<label className="label">Name</label>
							<input
								type="text"
								name="fullName"
								className="form-control"
								value={ tutorSettingDataState?.emergencyContact?.fullName }
								onChange={(e) => {
									tutorSettingDataState = tutorSettingDataState ? tutorSettingDataState : {};
									if ( tutorSettingDataState["emergencyContact"] ) {
										tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState })
									} else {
										tutorSettingDataState["emergencyContact"] = {};
										tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState });
									}
								}}
							/>
							<label className="label">Relationship</label>
							<input
								type="text"
								name="relationship"
								className="form-control"
								value={ tutorSettingDataState?.emergencyContact?.relationship }
								onChange={(e) => {
									tutorSettingDataState = tutorSettingDataState ? tutorSettingDataState : {};
									if ( tutorSettingDataState["emergencyContact"] ) {
										tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState })
									} else {
										tutorSettingDataState["emergencyContact"] = {};
										tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState });
									}
								}}
							/>
							<label className="label">Email</label>
							<input
								type="email"
								name="email"
								className="form-control"
								value={ tutorSettingDataState?.emergencyContact?.email }
								onChange={(e) => {
									tutorSettingDataState = tutorSettingDataState ? tutorSettingDataState : {};
									if ( tutorSettingDataState["emergencyContact"] ) {
										tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState })
									} else {
										tutorSettingDataState["emergencyContact"] = {};
										tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
										this.setState({ tutorSettingDataState });
									}
								}}
							/>		
							<div className="disabled">
								<span>United Kingdom (+44)</span>
								<i className="fa fa-lock"></i>
							</div>
							<div
								tabIndex="-1"
								className="comp_input"
								onBlur={ () => this.setState({ onFocusPhoneNumber: false }) }
								onFocus={ () => this.setState({ onFocusPhoneNumber: true }) }
								style={{ color: color, borderColor: borderColor, backgroundColor: backgroundColor }}
							>
								<span
									id="basic-addon1"
									className="mobile"
									onBlur={ () => this.setState({ onFocusPhoneNumber: false }) }
									onFocus={ () => this.setState({ onFocusPhoneNumber: true }) }
									style={{ color: onFocusPhoneNumber ? "#2cb46d" : color, borderColor: borderColor, backgroundColor: backgroundColor }}
								>
								+44
								</span>
								<input
									type="number"
									name="phoneNumber"
									aria-label="Username"
									className="form-control"
									aria-describedby="basic-addon1"
									onBlur={ () => this.setState({ onFocusPhoneNumber: false }) }
									onFocus={ () => this.setState({ onFocusPhoneNumber: true }) }
									value={ tutorSettingDataState?.emergencyContact?.phoneNumber }
									style={{ color: color, borderColor: borderColor, backgroundColor: backgroundColor }}
									onChange={(e) => {
										tutorSettingDataState = tutorSettingDataState ? tutorSettingDataState : {};
										if ( tutorSettingDataState["emergencyContact"] ) {
											tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
											this.setState({ tutorSettingDataState })
										} else {
											tutorSettingDataState["emergencyContact"] = {};
											tutorSettingDataState["emergencyContact"][e.target.name] = e.target.value;
											this.setState({ tutorSettingDataState });
										}
									}}
								/>
							</div>								
							<button className="green-button" onClick={ this.saveEmergencyContact }>Save</button>
						</div>
					) : (
						<ShowInfoPanel
							ValueTitle={"Emergency contact"}
							disabled={panel ? panel === "emergencyContact" : true}
							onEdit={ () => this.setState({ panel: "emergencyContact" }) }
							infoValue={`${
								tutorSettingDataState?.emergencyContact?.fullName
									? `${tutorSettingDataState?.emergencyContact.fullName}, ${tutorSettingDataState?.emergencyContact?.relationship}\n${tutorSettingDataState?.emergencyContact.email}, ${tutorSettingDataState?.emergencyContact.phoneNumber}`
									: ""
							}`}
						/>
					)}

					<hr className="hr"/>
					
				</Col>
			</Row>
			<PasswordConfirmationModal open={open} close={ () => this.setState({ open: false }) } />
		</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		TutorSettingReducer: { tutorSettingData },
		UserReducer: { user },
	} = state;

	return {
		tutorSettingData,
		user,
	};
};
const mapDispatchToprops = (dispatch) => {
	return {
		TutorSettingStoreData: (payload) =>
		dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
	};
};

export default connect( mapStateToProps, mapDispatchToprops )(PersonalInformation);
